import { useIntl } from 'react-intl';

/**
 * 简写: formatMessage({id: "order.please enter date"}) => $("please enter date")
 */
export const useTranslation = (prefix?: string) => {
  const { formatMessage } = useIntl();

  return (key: string, ...args) => {
    const keyWithPrefix = prefix ? `${prefix}.${key}` : key;

    return formatMessage({ id: keyWithPrefix, defaultMessage: keyWithPrefix }, ...args);
  };
};
